import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Back, Next, ChatToAFitter } from '../ControlButtons';
import {
  dataLayerGA4HyperlinksInText,
  dataLayerGA4SizeQuizStageNumber,
} from '../../../shared/utils/data-layer';
import Banner from '../Banner';

const Stage6 = ({
  backSize,
  cupSize,
  defaultNextProps,
  defaultPreviousProps,
  intl: { formatMessage },
  messages,
  resetSizeAndCaches,
  setCachedBackSize,
  setCachedCupSize,
  setTempCupCache,
}) => {
  const STAGE_NUMBER = '6';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <>
      <Back
        {...defaultPreviousProps(5, formatMessage(messages.restartQuiz))}
        customFunc={resetSizeAndCaches}
      />
      <div className="stage stage-6">
        <div className="wrap">
          {backSize && (
            <div className="backSuccess">
              <p>{formatMessage(messages.stage6para1)}</p>
              <Banner message={backSize} />
              <p>{formatMessage(messages.stage6para2)}</p>
            </div>
          )}
          <Next
            hasChevron
            disabled={false}
            {...defaultNextProps(1, 'Lets find out your cup size')}
            customFunc={() => {
              setCachedBackSize(backSize);
              setCachedCupSize(cupSize);
              setTempCupCache({ cupSize: cupSize, cupChange: 0 });
            }}
          />
          <p className="sub-header">
            {formatMessage(messages.stage6para3)}{' '}
            <a
              onClick={() => dataLayerGA4HyperlinksInText(STAGE_NUMBER)}
              href={`tel:${formatMessage(messages.phone)}`}
            >
              {formatMessage(messages.phone)}
            </a>{' '}
            {formatMessage(messages.stage6para3or)}
          </p>
          <ChatToAFitter stage={STAGE_NUMBER} />
        </div>
      </div>
    </>
  );
};

export default injectIntl(Stage6);

Stage6.propTypes = {
  Back: PropTypes.func,
  backSize: PropTypes.string,
  Banner: PropTypes.func,
  cupSize: PropTypes.string,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  resetSizeAndCaches: PropTypes.func,
  setCachedBackSize: PropTypes.func,
  setCachedCupSize: PropTypes.func,
  setTempCupCache: PropTypes.func,
};
